module.exports = __webpack_public_path__ + "static/f94c4c20fdfc91cf8bfc2bed04e59b1f.png";